import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { OperativesService } from 'src/app/operatives/services/operatives.service';
import { IRiskInfo } from 'src/app/message-models/risk-info.interface';
import { OperativeInfo } from 'src/app/domain-model/operative-info.class';
import { IRiskMatrixEntry } from 'src/app/message-models/risk-matrix-entry.interface';
import { IJobLevelInfo } from 'src/app/message-models/job-level.interface';
import { Router } from '@angular/router';
import { TrainingRecordModalService } from '../../../training-records/services/training-record-modal.service';
import { IJobTitleInfo } from '../../../message-models/job-title.interface';
import { DegreeOfSupervisionString, RiskMatrixLevel, RiskMatrixLevelString } from '../../../message-models/risk-matrix-level.enum';
import { Table } from 'primeng/table';
import { TrainingRecord } from '../../../domain-model/training-record.class';
import { ITrainingRecord } from '../../../message-models/training-record.interface';
import { ITrainingType } from '../../../message-models/training-record-type.interface';
import { TrainingRecordsService } from '../../../training-records/services/training-records.service';
import { OperativeModalService } from '../../services/operative-modal.service';
import { DateTimeWithZone } from '../../../common/date-time-with-zone.class';
import { ExtendedJobLevel } from '../../../message-models/extended-job-level.class';
import { ExtendedRiskInfo } from '../../../message-models/extended-risk-info.class';
import { IAllowedOperations, IUserInfo } from '../../../users/models/userInfo.interface';
import { ExportExcelService } from 'src/app/common/services/export-excel.service';
import { DatePipe } from '@angular/common';
import { IDateTimeWithZone } from '../../../common/date-time-with-zone.interface';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';
import { DocumentModalService } from '../../../documents/services/document-modal.service';
import { TrainingRecordDocumentService } from '../../../training-records/services/training-record-document.service';
import { IEmploymentStatus } from '../../../message-models/employment-status.interface';
import { isToday } from "date-fns";
import { BehaviorSubject } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { IOperativeTypeInfo } from '../../../message-models/operative-type.interface';
import { IBusinessUnitInfo } from '../../../message-models/business-unit.interface';
import { ICompanyJobTitle } from '../../../message-models/company-job-title.interface';
import { CompanyJobRoleService } from '../../../setting/job-role/services/company-job-role.service';
import { OurUserService } from '../../../users/services/user.service';
import { consts } from '../../../common/modals/consts';

@Component({
  selector: 'app-operative-list',
  templateUrl: './operative-list.component.html',
  styleUrls: ['./operative-list.component.scss']
})

export class OperativeListComponent implements OnInit, AfterViewInit {
  @Input() operatives: OperativeInfo[] = [];
  @Input() companyId: string;
  @Input() showTitleBar: boolean = true;
  @Input() showFilters: boolean = true;
  @Input() showMultiSelect: boolean = true;
  @Input() showOperativeMenus: boolean = true;
  @Input() showRowControllerButtons: boolean = true;
  @Input() isShowAllButtonVisible: boolean = false;
 
  searchFilter: string = '';
  @Output() searchFilterChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() loadedOperativesSubject: BehaviorSubject<boolean>;
  @ViewChild('operativesTable') operativesTable: Table;
  @Input() allowedOperations: IAllowedOperations = {} as IAllowedOperations;
  @Output() refreshOperativesRequested: EventEmitter<any> = new EventEmitter<any>();
  @Output() asOfDate: EventEmitter<any> = new EventEmitter<any>();
  @Output() loadAllHistoryOperatives: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() addOperativeTrainingRecordClicked: EventEmitter<any> = new EventEmitter<any>();
  loadingOperatives: boolean = false;
  showAll: boolean = true;
  riskMatrixLevelString: typeof RiskMatrixLevelString = RiskMatrixLevelString;
  degreeOfSupervisionString: typeof DegreeOfSupervisionString = DegreeOfSupervisionString;
  private _allEmploymentStatuses: IEmploymentStatus[] = [];
  allEmploymentStatusesOptions: any[] = [];
  matrixColumns: any[];


  @Input() set allEmploymentStatuses(employmentStatuses: IEmploymentStatus[]) {
    this._allEmploymentStatuses = employmentStatuses;
    if (!employmentStatuses) {
      return;
    }
    employmentStatuses?.forEach(r => {
      this.allEmploymentStatusesOptions.push({ label: r.name, value: r.id });
    });
  }

  get allEmploymentStatuses(): IEmploymentStatus[] {
    return this._allEmploymentStatuses;
  }

  private _allRisks: IRiskInfo[] = [];
  allRiskOptions: any[] = [];

  private trainingRecordTypes: ITrainingType[] = [];

  @Input() set allRisks(risks: IRiskInfo[]) {
    this._allRisks = risks;
    if (!risks) {
      return;
    }

    risks?.forEach(r => {
      this.allRiskOptions.push({ label: r.name, value: r.id });
    });
  }

  get allRisks(): IRiskInfo[] {
    return this._allRisks;
  }

  private _allJobLevels: IJobLevelInfo[] = [];
  allJobLevelOptions: any[] = [];

  @Input() set allJobLevels(jobLevels: IJobLevelInfo[]) {
    this._allJobLevels = jobLevels;
    if (!jobLevels) {
      return;
    }

    jobLevels?.forEach(r => {
      this.allJobLevelOptions.push({ label: r.name, value: r.id });
    });
  }

  get allJobLevels(): IJobLevelInfo[] {
    return this._allJobLevels;
  }

  private _allJobTitles: IJobTitleInfo[] = [];
  allJobTitleOptions: any[] = [];

  @Input() set allJobTitles(jobTitles: IJobTitleInfo[]) {
    this._allJobTitles = jobTitles;
    if (!jobTitles) {
      return;
    }

    jobTitles?.forEach(r => {
      this.allJobTitleOptions.push({ label: r?.name, value: r?.name });
    });
  }

  get allJobTitles(): IJobTitleInfo[] {
    console.log(this._allJobTitles);
    return this._allJobTitles;
  }
  /*company job title*/
  @Input() allCompanyJobTitles: ICompanyJobTitle[];
 
  /*Operative Types*/
  get allOperativeTypes(): IOperativeTypeInfo[] {
    return this._allOperativeTypes;
  }

  private _allOperativeTypes: IOperativeTypeInfo[] = [];
  allOperativeTypesOptions: any[] = [];

  @Input() set allOperativeTypes(operativeTypes: IOperativeTypeInfo[]) {
    this._allOperativeTypes = operativeTypes;
    if (!operativeTypes) {
      return;
    }

    operativeTypes?.forEach(r => {
      this.allOperativeTypesOptions.push({ label: r?.name, value: r?.id });
    });
  }
 

  /*Business Units*/
  get allBusinessUnits(): IBusinessUnitInfo[] {
    return this._allBusinessUnits;
  }

  private _allBusinessUnits: IBusinessUnitInfo[] = [];
  allBusinessUnitsOptions: any[] = [];

  @Input() set allBusinessUnits(businessUnits: IBusinessUnitInfo[]) {
    this._allBusinessUnits = businessUnits;
    if (!businessUnits) {
      return;
    }

    businessUnits?.forEach(r => {
      this.allBusinessUnitsOptions.push({ label: r?.name, value: r?.name });
    });
  }

  
  private _riskMatrix: IRiskMatrixEntry[] = [];
  allRiskMatrixOptions: any[] = [];

  @Input() set riskMatrix(riskMatrix: IRiskMatrixEntry[]) {
    this._riskMatrix = riskMatrix;
    if (!riskMatrix) {
      return;
    }

    riskMatrix?.forEach(r => {
      if (!this.allRiskMatrixOptions.find(o => o.value === r?.riskMatrixLevel)) {
        this.allRiskMatrixOptions.push({ label: this.degreeOfSupervisionString[r?.riskMatrixLevel], value: r?.riskMatrixLevel });
      }
    });
    this.allRiskMatrixOptions = this.allRiskMatrixOptions.sort(this.sortMatrixOptions);
  }

  get riskMatrix(): IRiskMatrixEntry[] {
    return this._riskMatrix;
  }

  private sortMatrixOptions(value1: any, value2: any): number {
    if (value1.value < value2.value) {
      return -1;
    }
    if (value1.value > value2.value) {
      return 1;
    }
    return 0;
  }

  columns: any[];
  tableColumns: any[];
  exportColumns: any[];
  operativeListToExport: any[] = [];
  @ViewChild('tt') table: Table;
  hoverImg: any = '<button pButton type="button" color="primary" class="waves-light">Left</button>';
  selectedOperatives: OperativeInfo[] = [];
  operativesAsOf: DateTimeWithZone = new DateTimeWithZone();
  disableAsOfDate: boolean;
  rowMenuItems: MenuItem[];
  first: number = 1;
  loggedInUser: IUserInfo;
 
  constructor(private trainingRecordModalService: TrainingRecordModalService,
    private trainingRecordsService: TrainingRecordsService,
    private operativesService: OperativesService,
    private operativeModalService: OperativeModalService,
    private router: Router,
    private datePipe: DatePipe,
    private trainingRecordDocumentService: TrainingRecordDocumentService,
    private documentModalService: DocumentModalService,
    private errorHandlingService: ErrorHandlingService,
    private companyJobRoleService: CompanyJobRoleService,
    private userService: OurUserService,
    private exportExcelService: ExportExcelService) {
  }

  isOnMobile: boolean = false;
  ngOnInit(): void {
    
    this.initialiseColumnDataTableColumns();
    this.operativesAsOf = new DateTimeWithZone({ dateTime: new Date().toISOString(), timeZone: '' });

    this.rowMenuItems = [
      {
        label: 'Add Training Record',
        icon: 'fas fa-graduation-cap',
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.addOperativeTrainingRecord($event)
      },
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.removeOperativeClicked($event)
      }
    ]

    this.matrixColumns = [
      { field: 'operativeName', header: 'Operative Name' },
      { field: 'businessUnit', header: 'Business Unit' },
      { field: 'operativeType', header: 'Operative Type' },
      { field: 'jobTitle', header: 'Job Title' },
      { field: 'course_1', header: 'Course 1' },
      { field: 'course_2', header: 'Course 2' },
      { field: 'course_3', header: 'Course 3' },
      { field: 'course_4', header: 'Course 4' },
      { field: 'course_5', header: 'Course 5' },
      { field: 'course_6', header: 'Course 6' },
      { field: 'course_7', header: 'Course 7' },
      { field: 'course_8', header: 'Course 8' },
      { field: 'course_9', header: 'Course 9' },
      { field: 'course_10', header: 'Course 10' },
      { field: 'course_11', header: 'Course 11' },
      { field: 'course_12', header: 'Course 12' },
      { field: 'course_13', header: 'Course 13' },
      { field: 'course_14', header: 'Course 14' },
      { field: 'course_15', header: 'Course 15' },
      { field: 'course_16', header: 'Course 16' },
      { field: 'course_17', header: 'Course 17' },
      { field: 'course_18', header: 'Course 18' },
      { field: 'course_19', header: 'Course 19' },
      { field: 'course_20', header: 'Course 20' },
      { field: 'course_21', header: 'Course 21' },
      { field: 'course_22', header: 'Course 22' },
      { field: 'course_23', header: 'Course 23' },
      { field: 'course_24', header: 'Course 24' },
      { field: 'course_25', header: 'Course 25' },
      { field: 'course_26', header: 'Course 26' },
      { field: 'course_27', header: 'Course 27' },
      { field: 'course_28', header: 'Course 28' },
      { field: 'course_29', header: 'Course 29' },
      { field: 'course_30', header: 'Course 30' },
      { field: 'course_31', header: 'Course 31' },
      { field: 'course_32', header: 'Course 32' },
      { field: 'course_33', header: 'Course 33' },
      { field: 'course_34', header: 'Course 34' },
      { field: 'course_35', header: 'Course 35' },
      { field: 'course_36', header: 'Course 36' },
      { field: 'course_37', header: 'Course 37' },
      { field: 'course_38', header: 'Course 38' },
      { field: 'course_39', header: 'Course 39' },
      { field: 'course_40', header: 'Course 40' },
      { field: 'course_41', header: 'Course 41' },
      { field: 'course_42', header: 'Course 42' },
      { field: 'course_43', header: 'Course 43' },
      { field: 'course_44', header: 'Course 44' },
      { field: 'course_45', header: 'Course 45' },
      { field: 'course_46', header: 'Course 46' },
      { field: 'course_47', header: 'Course 47' },
      { field: 'course_48', header: 'Course 48' },
      { field: 'course_49', header: 'Course 49' },
      { field: 'course_50', header: 'Course 50' },
      { field: 'course_51', header: 'Course 51' },
      { field: 'course_52', header: 'Course 52' },
      { field: 'course_53', header: 'Course 53' },
      { field: 'course_54', header: 'Course 54' },
      { field: 'course_55', header: 'Course 55' },
      { field: 'course_56', header: 'Course 56' },
      { field: 'course_57', header: 'Course 57' },
      { field: 'course_58', header: 'Course 58' },
      { field: 'course_59', header: 'Course 59' },
      { field: 'course_60', header: 'Course 60' },
      { field: 'course_61', header: 'Course 61' },
      { field: 'course_62', header: 'Course 62' },
      { field: 'course_63', header: 'Course 63' },
      { field: 'course_64', header: 'Course 64' },
      { field: 'course_65', header: 'Course 65' },
      { field: 'course_66', header: 'Course 66' },
      { field: 'course_67', header: 'Course 67' },
      { field: 'course_68', header: 'Course 68' },
      { field: 'course_69', header: 'Course 69' },
      { field: 'course_70', header: 'Course 70' },
      { field: 'course_71', header: 'Course 71' },
      { field: 'course_72', header: 'Course 72' },
      { field: 'course_73', header: 'Course 73' },
      { field: 'course_74', header: 'Course 74' },
      { field: 'course_75', header: 'Course 75' },
      { field: 'course_76', header: 'Course 76' },
      { field: 'course_77', header: 'Course 77' },
      { field: 'course_78', header: 'Course 78' },
      { field: 'course_79', header: 'Course 79' },
      { field: 'course_80', header: 'Course 80' },
      { field: 'course_81', header: 'Course 81' },
      { field: 'course_82', header: 'Course 82' },
      { field: 'course_83', header: 'Course 83' },
      { field: 'course_84', header: 'Course 84' },
      { field: 'course_85', header: 'Course 85' },
      { field: 'course_86', header: 'Course 86' },
      { field: 'course_87', header: 'Course 87' },
      { field: 'course_88', header: 'Course 88' },
      { field: 'course_89', header: 'Course 89' },
      { field: 'course_90', header: 'Course 90' },
      { field: 'course_91', header: 'Course 91' },
      { field: 'course_92', header: 'Course 92' },
      { field: 'course_93', header: 'Course 93' },
      { field: 'course_94', header: 'Course 94' },
      { field: 'course_95', header: 'Course 95' },
      { field: 'course_96', header: 'Course 96' },
      { field: 'course_97', header: 'Course 97' },
      { field: 'course_98', header: 'Course 98' },
      { field: 'course_99', header: 'Course 99' },
      { field: 'course_100', header: 'Course 100' },
    ];
  }

  onFilter(event) {
    console.log('Filter event:', event);
  }

  ngAfterViewInit(): void {
    this.loadedOperativesSubject?.subscribe(loadedOperatives => {
      if (loadedOperatives) {
        this.operativesTable.filterGlobal(this.searchFilter, 'contains');
      }
    });
  }

  initialiseColumnDataTableColumns() {
    this.columns = null;
    this.columns = [
      { field: 'firstName', header: 'First Name', type: 'text' },
      { field: 'lastName', header: 'Last Name', type: 'text' },
      //{ field: 'referenceNumbers', header: 'Reference Nos', type: 'text' },
      { field: 'businessUnit', header: 'Business Unit', type: 'text' },
      { field: 'operativeType', header: 'Operative Type', type: 'text' },
      { field: 'jobTitle', header: 'Job Role', type: 'text' },
      { field: 'currentWorkRisk', header: 'Work Risk', type: 'object' },
      { field: 'jobLevel', header: 'Job Level', type: 'object' },
      //{ field: 'currentEmploymentStatus', header: 'Employment', type: 'object' },
      { field: 'currentRiskMatrixLevel', header: 'Supervision', type: 'object' },
      { field: 'startedOn', header: 'Start Date', type: 'date' },
      { field: 'nextObservationFollowUp', header: 'Observation Due', type: 'date' },
      { field: 'totalCPDHours', header: 'Total CPD Hours', type: 'text' }
    ];
  }

  formatDate(date) {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }

    return date.getFullYear() + '-' + month + '-' + day;
  }

  onDateSelect(value) {
    this.table.filter(this.formatDate(value), 'date', 'equals');
  }

  viewOperativeClicked(operative: any) {
    this.router.navigateByUrl('/operative/' + operative.id);
  }

  getSupervisionLevel(riskMatrixLevel: RiskMatrixLevel): string {
    switch (riskMatrixLevel) {
      case RiskMatrixLevel.low:
        return 'Low';
      case RiskMatrixLevel.warning:
        return 'Medium';
      case RiskMatrixLevel.danger:
        return 'High';
    }
    return 'black';
  }

  private getTrainingTypesAndOpenModal() {
    this.trainingRecordsService.getTrainingTypesForCompany(this.companyId).subscribe(results => {
      this.trainingRecordTypes.length = 0;
      results.forEach(t => {
        this.trainingRecordTypes.push(t);
      });
      this.openTrainingRecordModal();
    });
  }

  private getTrainingTypes() {
    this.trainingRecordsService.getTrainingTypesForCompany(this.companyId).subscribe(results => {
      this.trainingRecordTypes.length = 0;
      results?.forEach(t => {
        this.trainingRecordTypes.push(t);
      });
    });
  }

  addTrainingToSelectedOperatives() {
    if (this.trainingRecordTypes.length == 0) {
      this.getTrainingTypesAndOpenModal();
    } else {
      this.openTrainingRecordModal();
    }
  }

  private openTrainingRecordModal() {
    this.trainingRecordModalService.openTrainingRecordEditorModal('Add New Training Record to ' + this.selectedOperatives.length + ' operatives',
      this.trainingRecordTypes, true, this.selectedOperatives.length > 1).subscribe(trainingRecordModalRef => {
        trainingRecordModalRef.content.saveTrainingRecordClicked.subscribe(trainingRecordResult => {
          if (trainingRecordResult !== null) {
            this.selectedOperatives?.forEach(operative => {
              let editedTrainingRecord = new TrainingRecord(trainingRecordResult as ITrainingRecord);
              editedTrainingRecord.operativeId = operative.id;
              this.loadingOperatives = true;
              this.trainingRecordsService.createOrUpdateTrainingRecord(editedTrainingRecord).subscribe(newTrainingRecord => {
                if (newTrainingRecord) {
                  this.trainingRecordModalService.modalRef.dynamicDialogRef.close();
                }
                this.loadingOperatives = false;
              });
            });
            this.selectedOperatives = [];
            this.refreshOperativesRequested.emit(this.operativesAsOf.dateTime);
          }
        });
        if (this.selectedOperatives.length === 1) {
          trainingRecordModalRef.content.saveNewTrainingRecordDocumentRequested.subscribe(trainingRecordResult => {
            if (trainingRecordResult !== null) {

              let editedTrainingRecord = new TrainingRecord(trainingRecordResult as ITrainingRecord);
              editedTrainingRecord.operativeId = this.selectedOperatives[0].id;
              this.trainingRecordsService.createOrUpdateTrainingRecord(editedTrainingRecord).subscribe(newTrainingRecord => {
                if (newTrainingRecord) {
                  this.trainingRecordModalService.modalRef.dynamicDialogRef.close();
                  this.addTrainingRecordDocument(newTrainingRecord);
                }
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                  // this.router.navigateByUrl('/dashboard');
                });
              });


            }
          });
        }

        trainingRecordModalRef.content.saveNewTrainingRecordTypeRequested.subscribe(newTrainingType => {
          if (newTrainingType !== null) {
            newTrainingType.companyId = this.companyId;
            this.trainingRecordsService.createOrUpdateCompanyTrainingType(newTrainingType).subscribe(trainingType => {
              if (trainingType) {
                this.getTrainingTypes();
              }
            });
          }
        });
      });
  }  

  public removeSelectedOperatives() {
    if (this.selectedOperatives.length === 0) {
      return;
    }

    let headerText = 'Confirm Removal of ' + this.selectedOperatives.length + ' Operatives';
    if (this.selectedOperatives.length === 1) {
      headerText = 'Confirm Removal of ' + this.selectedOperatives[0]?.firstName + ' ' + this.selectedOperatives[0]?.lastName;
    }

    this.operativeModalService.openConfirmLeaveOperativesModal(headerText)
      .subscribe(confirmLeaveModalRef => {
        confirmLeaveModalRef.content.removeOperativesRequested.subscribe(asOf => {
          if (asOf) {
            this.loadingOperatives = true;
            this.selectedOperatives?.forEach(operative => {
              this.operativesService.removeOperativeFromCompany(operative, asOf).subscribe(result => {
                this.selectedOperatives = [];
                this.loadingOperatives = false;
                this.refreshOperativesRequested.emit();
              });
            });
          } else if (this.selectedOperatives.length === 1) {
            this.selectedOperatives = [];
          }
        }
        );
      });
  }

  public removeOperativeClicked(operative: OperativeInfo) {
    this.selectedOperatives = [];
    this.selectedOperatives.push(operative);
    this.removeSelectedOperatives();
  }

  getOperativesAsOf() {
    if (this.operativesAsOf?.dateTime) {
      this.asOfDate.emit(this.operativesAsOf?.dateTime);
    } else {
      this.asOfDate.emit('');
    }
    this.refreshOperativesRequested.emit(this.operativesAsOf.dateTime);
  }

  addOperativeTrainingRecord(operative: OperativeInfo) {
    this.trainingRecordsService.getTrainingTypesForCompany(this.companyId).subscribe(results => {
      this.trainingRecordTypes.length = 0;
      results.forEach(t => {
        this.trainingRecordTypes.push(t);
      });
      this.trainingRecordModalService.openTrainingRecordEditorModal('Add New Training Record to ' + operative.fullName,
        this.trainingRecordTypes, true, false).subscribe(trainingRecordModalRef => {
          trainingRecordModalRef.content.saveTrainingRecordClicked.subscribe(trainingRecordResult => {
            if (trainingRecordResult !== null) {
              let editedTrainingRecord = new TrainingRecord(trainingRecordResult as ITrainingRecord);
              editedTrainingRecord.operativeId = operative.id;
              this.loadingOperatives = true;
              this.trainingRecordsService.createOrUpdateTrainingRecord(editedTrainingRecord).subscribe(newTrainingRecord => {
                if (newTrainingRecord) {
                  this.trainingRecordModalService.modalRef.dynamicDialogRef.close();
                }
                this.loadingOperatives = false;
              });
            }
          });
          trainingRecordModalRef.content.saveNewTrainingRecordTypeRequested.subscribe(newTrainingType => {
            if (newTrainingType !== null) {
              newTrainingType.companyId = this.companyId;
              this.trainingRecordsService.createOrUpdateCompanyTrainingType(newTrainingType).subscribe(trainingType => {
                if (trainingType) {
                  this.getTrainingTypes();
                }
              });
            }
          });
          trainingRecordModalRef.content.saveNewTrainingRecordDocumentRequested.subscribe(trainingRecordResult => {
            if (trainingRecordResult !== null) {
              let editedTrainingRecord = new TrainingRecord(trainingRecordResult as ITrainingRecord);
              editedTrainingRecord.operativeId = operative.id;
              this.trainingRecordsService.createOrUpdateTrainingRecord(editedTrainingRecord).subscribe(newTrainingRecord => {
                if (newTrainingRecord) {
                  this.trainingRecordModalService.modalRef.dynamicDialogRef.close();
                  this.addTrainingRecordDocument(newTrainingRecord);
                }
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                });
              });
            }
          });
        });
    });
  }

  addTrainingRecordDocument(trainingRecord: ITrainingRecord) {
    this.documentModalService.openDocumentUploaderModal({ documentCreationDate: trainingRecord?.achievedOn } as IEntityDocumentSummary
      , DocumentEntityType.trainingRecord, 'Add new document to ' + ' ' + trainingRecord?.trainingTypeName + ' training record')
      .subscribe(documentModalRef => {
        documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
          documentModalRef.dynamicDialogRef.close();
          documentUploadRequest.append('TrainingRecordId', trainingRecord?.id);
          documentUploadRequest.append('CompanyId', this.companyId);
          this.trainingRecordDocumentService.createOrUpdateTrainingRecordDocument(documentUploadRequest)
            .subscribe(trainingRecordSummary => {
            }, () => {
              this.errorHandlingService.showErrorWarning()?.subscribe(() => {
              });
            });
          this.selectedOperatives = [];
        });
        documentModalRef.content.cancelClicked?.subscribe(() => {
          documentModalRef.dynamicDialogRef.close();
        });
      });
  }

  addOperative() {
    const newOperative = new OperativeInfo();
    newOperative.companyId = this.companyId;

    newOperative.currentBusinessUnitId = consts.emptyGuid;
    const defaultEmploymentStatus = this.allEmploymentStatuses.find(s => s.isDefault);
    newOperative.currentEmploymentStatusId = defaultEmploymentStatus?.id;

    const jobLevels: ExtendedJobLevel[] = [];
    this.allJobLevels?.forEach(l => {
      jobLevels.push(new ExtendedJobLevel(l));
    });

    const risks: ExtendedRiskInfo[] = [];
    this.allRisks?.forEach(r => {
      risks.push(new ExtendedRiskInfo(r));
    });
    
   
    this.operativeModalService.openOperativeEditorModal(newOperative, 'Add a New Operative',
      this.allJobTitles, this.allCompanyJobTitles, jobLevels, risks, this.allEmploymentStatuses, this.allOperativeTypes, this.allBusinessUnits, true).subscribe(modalRef => {
        modalRef.content.saveOperativeRequested.subscribe(operative => {
          if (operative) {
            this.loadingOperatives = true;
            this.operativesService.createOrUpdateOperative(operative).subscribe(result => {
              if (result) {
                this.loadingOperatives = false;
                this.refreshOperativesRequested.emit();
                this.operativesAsOf = new DateTimeWithZone(result.latestEngagementFrom as IDateTimeWithZone);
                this.getOperativesAsOf();
              }
            });
          }
          this.loadingOperatives = false;
        });
      });
  }

  exportToExcel() {
    this.operativeListToExport = [];
    if (this.operativesAsOf?.dateTime) {
      this.exportColumns = null;
      this.exportColumns = [
        { field: 'firstName', header: 'First Name', type: 'text' },
        { field: 'lastName', header: 'Last Name', type: 'text' },
        { field: 'referenceNumbers', header: 'Reference Nos' },
        { field: 'businessUnit', header: 'Business Unit' },
        { field: 'operativeType', header: 'Operative Type' },
        { field: 'jobTitle', header: 'Job Role' },
        { field: 'currentRisk', header: 'Work Risk' },
        { field: 'currentJobLevel', header: 'Job Level' },
        { field: 'employmentStatus', header: 'Employment' },
        { field: 'riskMatrixLevel', header: 'Supervision' },
        { field: 'startedOn', header: 'Start Date' },
        { field: 'nextObservationFollowUp', header: 'Observation Due' },
        { field: 'endedOn', header: 'Ended On' + ' - (As of: ' + this.datePipe.transform(this.operativesAsOf?.dateTime, 'dd/MM/yyyy') + ')' },
        { field: 'totalCPDHours', header: 'Total CPD Hours' }

      ];
    } else {
      this.exportColumns = null;
      this.exportColumns = [
        { field: 'firstName', header: 'First Name', type: 'text' },
        { field: 'lastName', header: 'Last Name', type: 'text' },
        { field: 'referenceNumbers', header: 'Reference Nos' },
        { field: 'businessUnit', header: 'Business Unit' },
        { field: 'operativeType', header: 'Operative Type' },
        { field: 'jobTitle', header: 'Job Role' },
        { field: 'currentRisk', header: 'Work Risk' },
        { field: 'currentJobLevel', header: 'Job Level' },
        { field: 'employmentStatus', header: 'Employment' },
        { field: 'riskMatrixLevel', header: 'Supervision' },
        { field: 'startedOn', header: 'Start Date' },
        { field: 'nextObservationFollowUp', header: 'Observation Due' },
        { field: 'totalCPDHours', header: 'Total CPD Hours' }

      ];
    }
    this.operatives?.forEach(element => {
      const tempObject = {
        firstName: element?.firstName,
        lastName: element?.lastName,
        referenceNumbers: element?.referenceNumbers,
        businessUnit: element?.businessUnit,
        operativeType: element?.operativeType,
        jobTitle: element?.jobTitle,
        currentRisk: element?.currentRisk,
        currentJobLevel: element?.currentJobLevel,
        employmentStatus: element?.currentEmploymentStatus.label,
        riskMatrixLevel: element?.currentRiskMatrixLevel?.label,
        startedOn: this.datePipe.transform(element.latestEngagementFrom?.dateTime, 'dd/MM/yyyy'),
        nextObservationFollowUp: this.datePipe.transform(element?.nextObservationFollowUp, 'dd/MM/yyyy'),
        endedOn: this.datePipe.transform(element.latestEngagementTo?.dateTime, 'dd/MM/yyyy'),
        totalCPDHours: element?.totalCPDHours,
      };
      this.operativeListToExport.push(tempObject);

    });
    this.exportExcelService.exportToExcel(this.operativeListToExport, this.exportColumns, 'Operatives List')
  }

  exportTrainingMatrix() {
    //get data
    this.trainingRecordsService.getTrainingMatrixForCompany(this.companyId).subscribe(trainingMatrix => {
      //send for export
      this.exportExcelService.exportTrainingMatrix(trainingMatrix, this.matrixColumns, 'Company Operative Training Matrix')
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {

      });
    })
  };

  showAllToggled() {
    this.disableAsOfDate = !this.showAll;
    if (!this.showAll) {
      this.loadAllHistoryOperatives.emit(true);
    } else {
      this.getOperativesAsOf()
    }
  }

  showEndDate() {
    if (!this.showAll)
      return true;

    if (!this.operativesAsOf?.dateTime)
      return false;

    const filterDate = new Date(this.operativesAsOf.dateTime);
    return !isToday(filterDate);
  }
}
